'use client'
import { UNAVAILABLE_VALUE } from '../../consts.js';

/* eslint-disable prefer-destructuring */
const categorizeValue = (value) => {
    if (Number.isNaN(value))
        return { symbol: '', value: 0 };
    if (value >= 1e15)
        return '>999T';
    if (value >= 1e12)
        return { symbol: 'T', value: Math.round(value / 1e11) / 10 };
    if (value >= 1e9)
        return { symbol: 'B', value: Math.round(value / 1e8) / 10 };
    if (value >= 1e6)
        return { symbol: 'M', value: Math.round(value / 1e5) / 10 };
    return { symbol: '', value };
};
const addSymbol = (value, symbol) => {
    if (!symbol)
        return value;
    if (symbol === 'USD')
        return `$${value}`;
    return `${value} ${symbol}`;
};
const formatValue = ({ value, symbol, withFixedZeros = false, maxDecimals, }) => {
    if (value === UNAVAILABLE_VALUE)
        return addSymbol(UNAVAILABLE_VALUE, symbol);
    if (value === undefined)
        return undefined;
    const parsed = value === '' ? 0 : parseFloat(value.toString());
    const categorized = categorizeValue(parsed);
    const categorySymbol = typeof categorized === 'object' ? categorized.symbol : '';
    let formattedValue;
    if (typeof categorized === 'object') {
        const fixedValue = withFixedZeros
            ? categorized.value.toFixed(2)
            : categorized.value.toString();
        const [integerPart, decimalPart] = fixedValue.split('.');
        // Add commas
        const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        if (maxDecimals !== undefined &&
            decimalPart &&
            decimalPart.length > maxDecimals) {
            const rounded = parseFloat(`0.${decimalPart}`)
                .toFixed(maxDecimals)
                .split('.')[1];
            formattedValue = `${formattedInteger}.${rounded}`;
        }
        else {
            formattedValue = decimalPart
                ? `${formattedInteger}.${decimalPart}`
                : formattedInteger;
        }
    }
    else
        formattedValue = categorized;
    return addSymbol(formattedValue + categorySymbol, symbol);
};

export { formatValue };
